import { Box, Divider, FormControlLabel, ListItemIcon, Radio, RadioGroup } from '@mui/material';
import { InsertDriveFileOutlined } from '@mui/icons-material';
import { RoundedPopover } from '@/components/Popover/RoundedPopover';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { BodyText } from '@/components/BodyText';
import { DownloadFormat } from '@/utils/downloadUtils';
import { UploadTestIds } from '@/enums/uploadTestIds.enum';

export const UploadExportPopover = ({
  open,
  anchorEl,
  onClose,
  selectedOption,
  onOptionChange,
  onExport,
  currentTabCount,
  allFilesCount,
}: {
  open: boolean;
  anchorEl: HTMLButtonElement | undefined;
  onClose: () => void;
  selectedOption: 'current' | 'all';
  onOptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onExport: (format: DownloadFormat) => void;
  currentTabCount: number;
  allFilesCount: number;
}) => {
  return (
    <RoundedPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box sx={{ minWidth: '200px' }}>
        <RadioGroup value={selectedOption} onChange={onOptionChange}>
          <FormControlLabel
            value='current'
            control={<Radio size='small' />}
            label={`Export Current Tab (${currentTabCount})`}
            sx={{ margin: '8px 0 2px 6px', paddingRight: '16px' }}
            data-testid={UploadTestIds.UploadStatusExportCurrent}
          />
          <FormControlLabel
            value='all'
            control={<Radio size='small' />}
            label={`Export All (${allFilesCount})`}
            sx={{ margin: '0 0 8px 6px', paddingRight: '16px' }}
            data-testid={UploadTestIds.UploadStatusExportAll}
          />
        </RadioGroup>
        <Divider />
        <StyledList>
          {(['csv', 'xlsx'] as DownloadFormat[]).map(format => (
            <StyledListItem
              key={format}
              onClick={() => onExport(format)}
              sx={{ cursor: 'pointer' }}
              data-testid={
                format === 'csv' ? UploadTestIds.UploadStatusExportCsv : UploadTestIds.UploadStatusExportXlsx
              }
            >
              <ListItemIcon>
                <InsertDriveFileOutlined color='action' sx={{ fontSize: '18px' }} />
              </ListItemIcon>
              <BodyText>{format.toUpperCase()}</BodyText>
            </StyledListItem>
          ))}
        </StyledList>
      </Box>
    </RoundedPopover>
  );
};
